<template>

    <VueFinalModal 
        v-model="showBuscaPersona" 
        class="modal-container" 
        content-class="modal-content4"
        :clickToClose="true"
        :escToClose="true"
        :focusTrap="true"
        :lockScroll="true"
    >
        <buscaPersona @persona-seleccionada="onPersonaSeleccionada" />
    </VueFinalModal>

    <div class="mb-3">

        <form role="form" autocomplete="off" @submit.prevent="onSubmitSend">
            <div class="row ">
                <!-- Tipo de Identificación -->
                <div class="col-md-6">
                    <label class="form-control-label mb-3">Tipo de Identificación *</label>
                    <select class="form-select form-select-sm" v-model="pacientes.tipoIdentificacion"
                        @change="onTipoIdentificacionChange">
                        <option value="" disabled>Seleccione</option>
                        <option value="CEDULA">Cédula de Identidad</option>
                        <option value="PASAPORTE">Pasaporte</option>
                        <option value="TEMPORAL">Temporal</option>
                    </select>
                </div>

                <!-- Número de Identificación -->
                <div class="col-md-6">
                    <label class="form-control-label d-flex align-items-center">
                        Número de Identificación *
                        <div class="ms-4">
                            <div class="form-check form-check-inline mb-0">
                                <label class="form-control-label form-check-label" for="versionV1">V1</label>
                                <input class="form-control-label form-check-input" type="radio" name="version"
                                    id="versionV1" value="v1" v-model="versionSeleccionada" checked>
                            </div>
                            <div class="form-check form-check-inline mb-0">
                                <label class="form-check-label" for="versionV2">V2</label>
                                <input class="form-check-input" type="radio" name="version" id="versionV2" value="v2"
                                    v-model="versionSeleccionada">
                            </div>
                        </div>
                    </label>
                    <div class="d-flex align-items-center">
                        <input type="text" class="form-control form-control-sm me-1"
                            v-model="pacientes.numeroIdentificacion" :disabled="!isNumeroIdentificacionEnabled"
                            :maxlength="maxLength" autocomplete="off" required @input="validateNumeroIdentificacion" />
                        <button type="button" class="btn btn-primary btn-sm" :disabled="!isBuscarButtonEnabled"
                            @click="buscarIdentificacion">
                            <i class="fas fa-sync text-sm"></i>
                        </button>
                    </div>
                </div>

                <!-- Nombres -->
                <div class="col-md-6">
                    <label class="form-control-label">Nombres *</label>
                    <input ref="nombresInput" type="text" class="form-control form-control-sm"
                        v-model="pacientes.nombres" :disabled="!isDatosEnabled" required />
                </div>

                <!-- Apellidos -->
                <div class="col-md-6">
                    <label class="form-control-label">Apellidos *</label>
                    <input ref="apellidosInput" type="text" class="form-control form-control-sm"
                        v-model="pacientes.apellidos" :disabled="!isDatosEnabled" required />
                </div>

                <!-- Año de Nacimiento -->
                <div v-if="!isMobile" class="col-md-4">
                    <label class="form-control-label">Año de Nacimiento: * dd/mm/año</label>
                    <input :disabled="!isDatosEnabled" v-model="pacientes.nacimiento" autocomplete="off" required
                        class="form-control form-control-sm" type="date" />
                </div>

                <div v-else class="col-md-4">
                    <label class="form-control-label">Año de Nacimiento: * dd/mm/año</label>
                    <input :disabled="!isDatosEnabled" v-model="pacientes.nacimiento" @input="validarFormatoFecha"
                        autocomplete="off" required class="form-control form-control-sm" type="text"
                        placeholder="DD/MM/YYYY" maxlength="10" />
                    <small class="text-danger" v-if="errorFecha">{{ errorFecha }}</small>
                </div>

                <!-- Estado Civil -->
                <div class="col-md-4">
                    <label class="form-control-label">Estado Civil *</label>
                    <select :disabled="!isDatosEnabled" class="form-select form-select-sm"
                        v-model="pacientes.estadoCivil">
                        <option value="" disabled>Seleccione</option>
                        <option value="SOLTERO(A)">SOLTERO(A)</option>
                        <option value="CASADO(A)">CASADO(A)</option>
                        <option value="VIUDO(A)">VIUDO(A)</option>
                        <option value="DIVORCIADO(A)">DIVORCIADO(A)</option>
                    </select>
                </div>

                <!-- Sexo -->
                <div class="col-md-4">
                    <label class="form-control-label">Sexo *</label>
                    <select :disabled="!isDatosEnabled" class="form-select form-select-sm" v-model="pacientes.sexo">
                        <option value="" disabled>Seleccione</option>
                        <option value="HOMBRE">HOMBRE</option>
                        <option value="MUJER">MUJER</option>
                    </select>
                </div>

                <!-- Celular -->
                <div class="col-md-6">
                    <label class="form-control-label">Celular *</label>
                    <MazPhoneNumberInput type="tel" default-country-code="EC" style="width: 100%"
                        v-model="pacientes.celular" no-flags no-example show-code-on-list size="sm" color="info"
                        @update="onPhoneUpdate" :translations="{
                            countrySelector: {
                                placeholder: 'Código',
                                error: 'Elija un pais',
                            },
                            phoneInput: {
                                placeholder: 'Nro. celular',
                                example: 'Ejemplo:',
                            },
                        }" />
                </div>

                <!-- Correo Electrónico -->
                <div class="col-md-6">
                    <label class="form-control-label">Correo Electrónico</label>
                    <input type="email" class="form-control" v-model="pacientes.correo"
                        placeholder="ejemplo@correo.com" />
                </div>


                <!-- Ocupacion -->
                <div class="col-md-12">
                    <label class="form-control-label">Ocupación:</label>
                    <textarea ref="ocupacionInput" class="form-control" v-model="pacientes.ocupacion"
                        placeholder="Describa la ocupación"></textarea>
                </div>

            </div>

            <!-- Botones -->
            <div class="d-flex justify-content-end mt-4">
                <button style="background: #0078be!important;" type="submit" class="btn btn-success btn-sm me-2"
                    :class="{ 'w-100': isMobile }">
                    {{ title }}
                </button>
            </div>




        </form>

    </div>
</template>

<script>
/* eslint-disable */
import buscaPersona from './buscaPersona.vue';
import { VueFinalModal } from "vue-final-modal";
import "vue-final-modal/style.css";

export default {
    name: "FormularioHistoriaClinica",
    components: {
        buscaPersona,
        VueFinalModal
    },
    emits: ['carga-pacientes'],
    props: {
        title: {
            type: String,
            required: true
        },
        enviarsend: {
            type: Object,
            required: false,
            default: null
        }
    },
    data() {

        let datos = JSON.parse(localStorage.getItem("userData"));

        return {
            isMobile: this.$isMobile,
            showBuscaPersona: false,
            tokenAuth: localStorage.getItem("tokenAuth"),
            movilValido: false,
            pacientes: {
                tipoIdentificacion: "",
                numeroIdentificacion: "",
                nacimiento: "",
                nombres: "",
                apellidos: "",
                estadoCivil: "",
                sexo: "",
                celular: "",
                correo: "",
                ocupacion: "",
                user: datos.email,
                cod_paciente: ""
            },
            isNumeroIdentificacionEnabled: false,
            isBuscarButtonEnabled: false,
            isDatosEnabled: false,
            versionSeleccionada: 'v1',
            errorFecha: '',
        };
    },

    computed: {
        maxLength() {
            return this.pacientes.tipoIdentificacion === "cedula" ? 10 : 20;
        },
        placeholderText() {
            return this.pacientes.tipoIdentificacion === "cedula"
                ? "Ingrese 10 dígitos"
                : "Ingrese hasta 20 caracteres";
        },
    },

    watch: {
        'pacientes.nombres'(newValue) {
            this.pasarAMayusculas('nombres', 'nombresInput', newValue);
        },
        'pacientes.apellidos'(newValue) {
            this.pasarAMayusculas('apellidos', 'apellidosInput', newValue);
        },
        'pacientes.ocupacion'(newValue) {
            this.pasarAMayusculas('ocupacion', 'ocupacionInput', newValue);
        },
    },

    methods: {

        pasarAMayusculas(campo, refName, valor) {
            if (typeof valor !== 'string') return;

            const upper = valor.toUpperCase();
            if (upper === valor) return;

            const input = this.$refs[refName];
            const cursorPosition = input ? input.selectionStart : upper.length;
            this.pacientes[campo] = upper;
            this.$nextTick(() => {
                if (input && typeof input.setSelectionRange === 'function') {
                    input.setSelectionRange(cursorPosition, cursorPosition);
                }
            });
        },

        onPhoneUpdate(event) {
            const valido = !!event?.isValid;
            if (this.movilValido !== valido) {
                this.movilValido = valido;
            }
        },

        onPersonaSeleccionada(persona) {
            this.pacientes.numeroIdentificacion = persona.identificacion;
            this.buscarIdentificacion();
            this.$nextTick(() => {
                this.showBuscaPersona = false;
            });
        },

        limpiarFormulario() {
            this.pacientes.numeroIdentificacion = "";
            this.pacientes.nombres = "";
            this.pacientes.apellidos = "";
            this.pacientes.nacimiento = "";
            this.pacientes.estadoCivil = "";
            this.pacientes.sexo = "";
            this.pacientes.correo = "";
            this.pacientes.ocupacion = "";
            this.pacientes.celular = "";
        },

        onTipoIdentificacionChange() {
            const { tipoIdentificacion } = this.pacientes;

            switch (tipoIdentificacion) {
                case "CEDULA":
                    this.isNumeroIdentificacionEnabled = true;
                    this.isBuscarButtonEnabled = true;
                    this.isDatosEnabled = false;
                    this.pacientes.numeroIdentificacion = "";
                    break;
                case "TEMPORAL":
                    this.isNumeroIdentificacionEnabled = false;
                    this.isBuscarButtonEnabled = false;
                    this.isDatosEnabled = true;
                    this.pacientes.numeroIdentificacion = this.generateCode(10, 'aA#');
                    break;
                default:
                    this.isNumeroIdentificacionEnabled = true;
                    this.isBuscarButtonEnabled = false;
                    this.isDatosEnabled = true;
                    if (this.title === "Editar") return;
                    this.limpiarFormulario();
                    break;
            }
        },

        habilitarNuevaConsulta() {
            this.isNumeroIdentificacionEnabled = true
            this.isBuscarButtonEnabled = true
        },

        async buscarIdentificacion() {

            if (this.pacientes.numeroIdentificacion === '') {


                this.showBuscaPersona = true
                return
                //return this.showError('Digíte el número de cédula')
            }
            const esCedula = /^\d+$/.test(this.pacientes.numeroIdentificacion.trim());

            if (!esCedula) {
                this.limpiarFormulario()
                this.showError('La cédula deben ser números')
                return
            }

            this.isNumeroIdentificacionEnabled = false;

            let datos = {
                "email": "info@juanbautista.com.ec",
                "token": "EdwY07J0BYruZy15oXqftHZ4pYDmHdPsOpzJrcThPCgYEBUO",
                "version": this.versionSeleccionada,
                "dni": this.pacientes.numeroIdentificacion
            }

            let aviso = null

            try {

                this.showLoading()

                const response = await this.$https2.post("/developers/getConsultarDni", datos);
                const datos2 = response.data?.data
                const nombres = datos2?.NombresSeparados?.Nombres

                if (response.data?.code === 200 && nombres) {
                    this.pacientes.nombres = nombres
                    this.pacientes.apellidos = datos2.NombresSeparados.Apellidos
                    this.pacientes.sexo = datos2.Sexo
                    this.pacientes.estadoCivil = datos2.EstadoCivil
                    this.pacientes.nacimiento = datos2.FechaNacimiento
                    this.isDatosEnabled = false
                    aviso = { tipo: "ok" }
                } else {
                    this.habilitarNuevaConsulta()
                    aviso = {
                        tipo: "reintentar",
                        title: "No se pudo consultar",
                        text: "Vuelva a consultar la cédula."
                    }
                }

            } catch (error) {
                this.habilitarNuevaConsulta()
                const status = error?.response?.status
                const data = error?.response?.data
                const message = data?.message || "El servicio de consulta no respondió. Puede volver a intentarlo."

                if (status === 404 || data?.code === 404) {
                    aviso = {
                        tipo: "reintentar",
                        title: "Cédula no encontrada",
                        text: "La cédula ingresada no existe. Puede corregirla y consultar de nuevo."
                    }
                } else if (status === 400 || data?.code === 400) {
                    aviso = {
                        tipo: "reintentar",
                        title: "Ocurrió algo!",
                        text: message
                    }
                } else {
                    aviso = {
                        tipo: "reintentar",
                        title: "No se pudo consultar",
                        text: message
                    }
                }
            } finally {
                this.hideLoading()
            }

            if (!aviso) return

            this.$swal.fire({
                title: aviso.tipo === "ok" ? "Consulta Éxitosa" : aviso.title,
                text: aviso.tipo === "ok" ? undefined : aviso.text,
                icon: aviso.tipo === "ok" ? "success" : "warning",
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn btn-primary"
                },
                buttonsStyling: false,
            });

        },

        validateNumeroIdentificacion() {
            // Restringir solo números si es cédula
            if (this.pacientes.tipoIdentificacion === "cedula") {
                this.pacientes.numeroIdentificacion = this.pacientes.numeroIdentificacion.replace(/[^0-9]/g, "");
            }
        },

        onSubmitSend(event) {
            event.preventDefault();

            if (!this.movilValido) {
                return alert('El movil no es válido')
            }

            // Convertir el formato de fecha si es input text (móvil)
            if (this.isMobile && this.pacientes.nacimiento) {
                const [dia, mes, año] = this.pacientes.nacimiento.split('/');
                this.pacientes.nacimiento = `${año}-${mes}-${dia}`;
            }

            if (this.title === 'Registrar') {
                this.getRegistrar()
            } else if (this.title === 'Editar') {
                this.getEditar()
            }
        },

        async getRegistrar() {

            try {

                if (this.pacientes.nombres === '') {
                    alert('Vuelva a consultar la cédula')
                    return
                }

                this.showLoading2('Registrando... espere')

                const response = await this.$https.post("/pacientes/getCrearPacientes", this.pacientes, { headers: { Authorization: this.tokenAuth } });

                this.$emit('carga-pacientes');

                if (response.data.code === 200) {
                    this.showOk('Grabación Éxitosa')
                    return
                }

            } catch (error) {
                if (error.response.status === 400) {

                    this.showErrorMejor(error.response.data.message)

                }
                if (error.response.status === 401) {
                    this.showSessionExpiredAlert()
                }


            }
            /* finally {

                this.hideLoading();

            } */

        },

        async getEditar() {

            try {

                this.showLoading2('Editando, por favor espere...')

                const response = await this.$https.post("/pacientes/getUpdatePacientes", this.pacientes, { headers: { Authorization: this.tokenAuth } });

                if (response.data.code === 200) {
                    this.showOk('Actualización Éxitosa')
                    //this.hideLoading()
                }

            } catch (error) {
                if (error.response.status === 400) {
                    this.showError(error.response.data.message)
                }
                if (error.response.status === 401) {
                    this.showSessionExpiredAlert()
                }
            }

        },

        validarFormatoFecha(event) {
            const fecha = event.target.value;
            this.errorFecha = '';

            // Si está vacío, no mostrar error
            if (!fecha) return;

            // Expresión regular para validar el formato DD/MM/YYYY
            const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
            const match = fecha.match(regex);

            if (!match) {
                this.errorFecha = 'El formato debe ser DD/MM/YYYY';
                return;
            }

            const dia = parseInt(match[1]);
            const mes = parseInt(match[2]);
            const año = parseInt(match[3]);

            // Validar rangos
            if (dia < 1 || dia > 31) {
                this.errorFecha = 'El día debe estar entre 1 y 31';
                return;
            }
            if (mes < 1 || mes > 12) {
                this.errorFecha = 'El mes debe estar entre 1 y 12';
                return;
            }
            if (año < 1900 || año > new Date().getFullYear()) {
                this.errorFecha = 'El año debe estar entre 1900 y el año actual';
                return;
            }

            // Validar días por mes
            const diasPorMes = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
            if (mes === 2 && ((año % 4 === 0 && año % 100 !== 0) || año % 400 === 0)) {
                diasPorMes[1] = 29; // Año bisiesto
            }
            if (dia > diasPorMes[mes - 1]) {
                this.errorFecha = `El mes ${mes} no puede tener más de ${diasPorMes[mes - 1]} días`;
                return;
            }

            // Si todo está bien, limpiar el error
            this.errorFecha = '';
        },

        initializeFormWithData(data) {
            if (data.tipo_identificacion === "CEDULA") {
                this.isNumeroIdentificacionEnabled = false;
                this.isDatosEnabled = false;
                this.isBuscarButtonEnabled = true;
            }

            this.pacientes = {
                ...this.pacientes,
                nombres: data.nombres || '',
                apellidos: data.apellidos || '',
                nacimiento: data.nacimiento || '',
                estadoCivil: data.estado_civil || '',
                sexo: data.sexo || '',
                celular: data.celular || '',
                correo: data.correo || '',
                ocupacion: data.ocupacion || '',
                tipoIdentificacion: data.tipo_identificacion || '',
                numeroIdentificacion: data.cedula || '',
                cod_paciente: data.cod_paciente || ''
            };
        },

    },
    mounted() {

        if (this.isMobile) {
            this.$eventBus.emit("activeShowMenu");
        }

        if (this.enviarsend) {
            this.initializeFormWithData(this.enviarsend);
        } else if (this.title === 'Registrar') {
            this.limpiarFormulario();
            this.isNumeroIdentificacionEnabled = true;
        }





    }
};
</script>

<style></style>